module.exports = __webpack_public_path__ + "img/feuilles.f0781811.png";